// Author thq
// Date 2022-04-04 18:10:58

class EmArchBdaRelSppBrs {
constructor({
        id = null,
        brsIdBda = '',
        brsCodeBda = '',
        bdaName = '',
        brsIdSpa = '',
        spaCode = '',
        spaName = '',
        brsServiceLife = '',
        brsInstallTime = '',
        brsInstallNum = '',
        brsLowerLimit = '',
        brsUpperLimit = '',
        remark = ''}
= {}) {
    this.id = id;
    this.brsIdBda = brsIdBda;
    this.brsCodeBda = brsCodeBda;
    this.bdaName = bdaName;
    this.brsIdSpa = brsIdSpa;
    this.spaCode = spaCode;
    this.spaName = spaName;
    this.brsServiceLife = brsServiceLife;
    this.brsInstallTime = brsInstallTime;
    this.brsInstallNum = brsInstallNum;
    this.brsLowerLimit = brsLowerLimit;
    this.brsUpperLimit = brsUpperLimit;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchBdaRelSppBrs();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'brsCodeBda',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.brsCodeBda',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'bdaName',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.bdaName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'spaName',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.spaName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'spaCode',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.spaCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'brsServiceLife',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.brsServiceLife',
        sortable: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'brsInstallTime',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.brsInstallTime',
        sortable: true,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'serviceDays',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.serviceDays',
        sortable: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'serviceRemainRate',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.serviceRemainRate',
        sortable: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'brsInstallNum',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.brsInstallNum',
        sortable: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'brsInventoryNum',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.brsInventoryNum',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'brsInventoryLoc',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.brsInventoryLoc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'brsLowerLimit',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.brsLowerLimit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'brsUpperLimit',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.brsUpperLimit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchBdaRelSppBrs.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    brsIdBdaFilter : '',
    brsNameBdaFilter : '',
    brsCodeBdaFilter : '',
    brsIdSpaFilter : '',
    brsNameSpaFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'brsNameBdaFilter',
        label: 'label.em.archive.emArchBdaRelSppBrs.filter.brsNameBda',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"brsIdBda":"id"}'
                }
        },
        {
        key: 'brsCodeBdaFilter',
        label: 'label.em.archive.emArchBdaRelSppBrs.filter.brsCodeBda',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'brsIdBda',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.brsIdBda',
        sortable: true,
        disabled: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'bdaName',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.bdaName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'brsIdSpa',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.brsIdSpa',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emSppSparePartsSpa'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"spaCode":"code","spaName":"name"}'
                }
        },
        {
        key: 'spaCode',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.spaCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'spaName',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.spaName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'brsServiceLife',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.brsServiceLife',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'brsInstallTime',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.brsInstallTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'brsInstallNum',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.brsInstallNum',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'brsLowerLimit',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.brsLowerLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'brsUpperLimit',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.brsUpperLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchBdaRelSppBrs.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmArchBdaRelSppBrs, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
